export const MEMBER_LIST = [
  {
    img: '/person.jpg',
    id: 0,
    name: 'MR. SANJEEV GUPTA',
    designation: 'Managing Director',
    detail:
      'He is the Promoter of the Company and he is holding the position of Managing Director. He has been associated with our Company since its inception. He has over two decades of experience as successful contractor in Mechanical, Electrical Projects, Electrical utility & shifting of NHAI projects, Infrastructure industry and various miscellaneous projects. He is the founder and overall business head of this company, having various contractual experience in business strategy. He worked with GAIL (India), NTPC, IGL, CUGL, EESL, NHAI, BINA Refinery etc.',
  },
  {
    img: '/person.jpg',
    id: 1,
    name: 'MRS. REENA GUPTA',
    designation: 'Managing Director',
    detail: null,
  },

  {
    img: '/person.jpg',
    id: 2,
    name: 'MR. SANJAY KUMAR GUPTA',
    designation: 'Director Project (Electrical)',
    detail:
      'A Electrical and Communication Engineer having more than 23 years of central government working Experience and working in this project since last 3 years.',
  },
  {
    img: '/person.jpg',
    id: 3,
    name: 'MR. AJAY GUPTA',
    designation: 'Director Project (Mining)',
    detail: null,
  },
  {
    img: '/person.jpg',
    id: 4,
    name: 'MR. SHAILENDRA GUPTA',
    designation: 'Director Project (Mechanical)',
    detail:
      'Mr. Shailendra Gupta, the distinguished Director of Project (Mechanical), brings over 15 years of invaluable experience in refinery and plant projects. His role is pivotal in overseeing the planning, execution, and successful completion of complex mechanical projects. Mr. Shailendra Gupta is adept at formulating strategic project plans, seamlessly coordinating with multidisciplinary teams, and ensuring rigorous adherence to project specifications and timelines. His strong leadership and innovative problem-solving abilities have consistently driven projects to successful outcomes. With profound expertise in mechanical engineering principles, Mr Shailendra Gupta upholds the highest standards of quality and efficiency in every project. His vast experience and unwavering dedication make him an indispensable asset to the organization.',
  },
  {
    img: '/person.jpg',
    id: 6,
    name: 'MR. SARVAGYA GUPTA',
    designation: 'Director',
    detail: null,
  },
  {
    img: '/person.jpg',
    id: 5,
    name: 'MR. RAMAKANT GUPTA',
    designation: 'General Manager ',
    detail:
      'He has more than 15 years of experience in thefieldof Process Piping, Structural Works and all types of Mechanical Maintenance of Refineries,Petrochemicals.',
  },
  // {
  //   img: '/person.jpg',
  //   id: 6,
  //   name: 'MR. HIMANSHU YADAV',
  //   designation: 'Project Manager',
  //   detail:
  //     'Himanshu Yadav is a dedicated Project Manager specializing in utility shifting projects. His expertise includes developing project plans, coordinating with stakeholders, and ensuring timely and efficient execution of tasks. Himanshu excels in monitoring project progress and conducting quality checks to meet project specifications and standards. He holds a specialized qualification in Electronics & Communication Engineering, enhancing his technical proficiency and project management capabilities.',
  // },
  {
    img: '/person.jpg',
    id: 7,
    name: 'MR. NITIN UPADHYAY',
    designation: 'Project Manager',
    detail:
      'Nitin Upadhyay is an experienced Project Manager with a significant role in executing projects like the street lighting national program and the safe city project. His expertise includes developing project plans, monitoring progress, and conducting quality checks to meet project specifications and standards. Known for his innovative problem-solving and strong decision-making skills, Nitin excels in coordinating with internal teams and external stakeholders to ensure successful project outcomes. He holds a specialized qualification in Instrumentation and Control Engineering, enhancing his technical proficiency and project management capabilities.',
  },
  // {
  //   img: '/person.jpg',
  //   id: 8,
  //   name: 'MR. VIKRANT GUPTA',
  //   designation: 'Accountant Manager',
  //   detail:
  //     'A Bachelor of Commerce graduate with 5 years of extensive experience in contract evaluation and accounts, bringing a strong foundation in financial management and analytical skills.',
  // },
  {
    img: '/person.jpg',
    id: 9,
    name: 'MR. PANKAJ KUMAR',
    designation: 'Sr Manager',
    detail:
      'A Bachelor of Computer Applications graduate with 6 years of extensive experience in software development and IT solutions, demonstrating a solid background in programming, systems analysis, and project management.',
  },
];

export const PROJECT_LIST = [
  {
    heading: 'Mining Works',
    projects: [
      {
        id: 1,
        sr: 1,
        loa: 'Letter No.2483/Khanij-30, Banda   15.11.2021',
        nameOfWork: 'Mining',
        clientAddr: 'MSTC & Gram-Maraulikadar, Gata No.333/7 Khand No. 5 Rakaba -23',
        woValue: null,
        exValue: null,
        startDate: '03.05.2023',
        endDate: '02.05.2028',
        duration: null,
        remarks: null,
      },
      {
        id: 2,
        sr: 2,
        loa: 'Letter No.2172/Khanij-30, Banda   21.10.2021',
        nameOfWork: 'Mining',
        clientAddr: 'MSTC & Gram-Bariyari, Tahseel- Naraini  Gata No.429 & 430,  Rakaba -13.362',
        woValue: null,
        exValue: null,
        startDate: '04.01.2024',
        endDate: '03.01.2029',
        duration: null,
        remarks: null,
      },
    ],
  },

  {
    heading: 'EESL Works',
    projects: [
      {
        id: 1,
        sr: 1,
        loa: 'EESL/06/2017-18/DIC-UP/LOA-1718345/9705 (DATED - 14/12/2017)',
        nameOfWork: 'EESL/06/2017-18/DIC-UP/LOA-1718345/9705 (DATED - 14/12/2017)',
        clientAddr: 'GOVERNMENT OF INDIA AS A JOINT VENTURE OF MINISTRY OF POWER',
        woValue: 447540960,
        exValue: null,
        startDate: null,
        endDate: null,
        duration: null,
        remarks: null,
      },
      {
        id: 2,
        sr: 2,
        loa: 'EESL/06/2017-18/DIC-UP/01/LOA-02 (DATED - 17/01/2018)',
        nameOfWork: 'EESL/06/2017-18/DIC-UP/01/LOA-02 (DATED - 17/01/2018)',
        clientAddr: 'GOVERNMENT OF INDIA AS A JOINT VENTURE OF MINISTRY OF POWER',
        woValue: '40,14,36,000',
        exValue: null,
        startDate: null,
        endDate: null,
        duration: null,
        remarks: null,
      },
    ],
  },
  {
    heading: 'ERECTION AND SHIFTING OF EXISTING UTILITY',
    projects: [
      {
        id: 1,
        sr: 1,
        loa: 'RCC/PWD/MIRZAPUR/CAMP-01/WO/12 (06/12/2018)',
        nameOfWork:
          'Work order for erection and shifting of existing utility along with rehabilitation and upgradation Allahabad-Mirzapur Road (NH-76E) in the state of Uttar Pradesh.',
        clientAddr: 'Government of Uttar Pradesh.',
        woValue: '7.65 Cr.',
        exValue: null,
        startDate: '6 Dec 2018',
        endDate: null,
        duration: null,
        remarks: 'Running',
      },
      {
        id: 2,
        sr: 2,
        loa: 'CCC/WO/2016/DESCON/067',
        nameOfWork:
          'Utility Shifting Work Of 4-Laning of Haridwar - Nagina Section of NH-74 from Km 0.000 to Km 71.614 (Design Chainage) in the States of Uttarakhand and Uttar Pradesh under NHDP Phase-IV on EPC mode.',
        clientAddr: 'Corsan Corviam Construction SA, Gurgaon, Haryana.',
        woValue: '35.40 Cr.',
        exValue: null,
        startDate: ' April 2017',
        endDate: null,
        duration: null,
        remarks: 'Running',
      },
    ],
  },
  {
    heading: 'LED Street Lights/Flood Lights Work',
    projects: [
      {
        id: 1,
        sr: 1,
        loa: null,
        nameOfWork:
          'Installation (Retrofit) , dismantling, testing, commissioning, repair and maintenance of LED Street lights/ Flood lights for period of 7 years in 75 districts of Uttar Pradesh.',
        clientAddr: 'GOVERNMENT OF INDIA AS A JOINT VENTURE OF MINISTRY OF POWER',
        woValue: '85 Cr.',
        exValue: null,
        startDate: null,
        endDate: null,
        duration: null,
        remarks: null,
      },
    ],
  },
  {
    heading: 'COMPOSITE /STRUCTURAL WORKS',
    projects: [
      {
        id: 1,
        sr: 1,
        loa: 'SHEL/NGP/DC & B/2011',
        nameOfWork: 'FABRICATION AND ERECTION OFSTRUCTRAL STEEL WORKS',
        clientAddr: 'SUNIL HI-TECH ENGINNEERS LIMITED',
        woValue: null,
        exValue: null,
        startDate: '15.01.2013',
        endDate: '---',
        duration: ' 12 Month',
        remarks: 'Completed',
      },
      {
        id: 2,
        sr: 2,
        loa: 'GAIL/PA10/20344/5600000864/SKG Dtd. 24.04.2010',
        nameOfWork: 'Composit works ( Civil- Mechanical & Electrical) for Flacker Unit at GAIL, Pata.',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '35.40 lac',
        exValue: '24 lac',
        startDate: '17.03.2010',
        endDate: '01-10-2010',
        duration: '4 Month',
        remarks: 'Completed',
      },
      {
        id: 3,
        sr: 3,
        loa: 'B & R/PCD/40054/LCT-54/WO/773 Dt. 21.05.2010',
        nameOfWork:
          'Fabrication, Erection, Welding, Testing & commissioning of Structural & Coil Work for 6th Funace at Gail, Pata',
        clientAddr: 'Bridge & Roof Co. (I) Ltd. Kolkata',
        woValue: '1.29 Crore',
        exValue: '1.37 Crore',
        startDate: '20.06.2010',
        endDate: '31-12-2010',
        duration: '6 Month',
        remarks: 'Completed',
      },
      {
        id: 4,
        sr: 4,
        loa: 'PED/M/100140 Dt. 17.12.2007',
        nameOfWork: 'Civil & Structural & Electrical Works For BORL, Bina (MP)',
        clientAddr: 'BOC India Limited ( A member of Linde group), Kolkata.',
        woValue: '1.87 Crore',
        exValue: '1.25 Crore',
        startDate: '05.01.2008',
        endDate: '01-08-2009',
        duration: '20 Months',
        remarks: 'Completed',
      },
    ],
  },

  {
    heading: 'PIPING WORKS',
    projects: [
      {
        id: 1,
        sr: 1,
        loa: 'GAIL/AU13/43943/5300020662/KMK',
        nameOfWork:
          'PIPE LINE MODIFICATION WORK IN SCRAPPER AREA IN CONNECT MAIN MAIN COMPRESSOR DISCHARGE TO24 AURAIYA',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '41.82 Lac',
        exValue: '42 Lac',
        startDate: '26.03.2012',
        endDate: '25.12.2012',
        duration: '9 Months',
        remarks: 'Completed',
      },
      {
        id: 2,
        sr: 2,
        loa: 'OIL/3062/12-13/023',
        nameOfWork: 'PIPING AND STRUCTRAL WORK FOR UNIT PIPING OUR PROJECT SITE GAILPATA',
        clientAddr: 'OFFSHORE INFRASTRUCTURE LIMITED',
        woValue: '50 Lac',
        exValue: '---',
        startDate: '30.08.2012',
        endDate: '---',
        duration: '---',
        remarks: 'Completed',
      },
      {
        id: 3,
        sr: 3,
        loa: 'OIL/3062/12-13/024',
        nameOfWork: 'PIPING AND STRUCTRAL WORK FOR UNIT PIPING OUR PROJECT SITE GAILPATA',
        clientAddr: 'OFFSHORE INFRASTRUCTURE LIMITED',
        woValue: '40 Lac',
        exValue: '---',
        startDate: '30.08.2012',
        endDate: '---',
        duration: '---',
        remarks: 'Completed',
      },
      {
        id: 4,
        sr: 4,
        loa: 'GAIL/PA11/35562/5600001448/VA Dtd. 29.03.2012',
        nameOfWork: 'PIPING FABRICATION & ERECTION WORK FOR EVRU',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '46.2 Lac',
        exValue: '---',
        startDate: '22.06.2004',
        endDate: '12.07.2007',
        duration: '3 Years',
        remarks: 'Completed',
      },
    ],
  },
  {
    heading: 'OPERATION & MAINTENANCE OF PNG SERVICES',
    projects: [
      {
        id: 1,
        sr: 1,
        loa: '6500001057 01.05.2009',
        nameOfWork: 'Rate Contract For O & M Of Existing PNG Services At Control Rooms In NCT Of Delhi',
        clientAddr: 'Indraprastha Gas Limited, Plot No. 4, IGL Bhawan, Sector- 9, R.K. Puram, New Delhi',
        woValue: '3.18 Crore',
        exValue: '3.38 Crore',
        startDate: '22.06.2009',
        endDate: '01.08.2011',
        duration: '3 Years',
        remarks: 'Completed',
      },
      {
        id: 2,
        sr: 2,
        loa: 'RCNMCR0707',
        nameOfWork: 'Rate Contract For O & M Of Existing PNG Services At Control Rooms In NCT Of Delhi',
        clientAddr: 'Indraprastha Gas Limited, Plot No. 4, IGL Bhawan, Sector- 9, R.K. Puram, New Delhi',
        woValue: '4.70 Crore',
        exValue: '4.42 Crore',
        startDate: '16.11.2007',
        endDate: '18.12.2008',
        duration: '1 Years',
        remarks: 'Completed',
      },
    ],
  },
  {
    heading: 'PE & GI PIPING NETWORK FOR PNG INSTALLATION',
    projects: [
      {
        id: 1,
        sr: 1,
        loa: '6500000891 27.10.2008',
        nameOfWork: 'Rate Contract For Providing new PNG Connections In NCT Of Delhi',
        clientAddr: 'Indraprastha Gas Limited, Plot No. 4, IGL Bhawan, Sector- 9, R.K. Puram, New Delhi - 110 022',
        woValue: '75,00,000',
        exValue: '----',
        startDate: '27.10.2008',
        endDate: 'Completed',
        duration: '12 Month',
        remarks: 'IGL/ND/C & P/P10162 Dtd. 30.03.2009',
      },
      {
        id: 2,
        sr: 2,
        loa: '6500000364 07.04.2007',
        nameOfWork: 'Rate Contract For Providing new PNG Connections In NCT Of Delhi',
        clientAddr: 'Indraprastha Gas Limited, Plot No. 4, IGL Bhawan, Sector- 9, R.K. Puram, New Delhi - 110 022',
        woValue: '45,00,000',
        exValue: '----',
        startDate: '07.04.2007',
        endDate: 'Completed',
        duration: '12 Month',
        remarks: 'Amended',
      },
      {
        id: 3,
        sr: 3,
        loa: '6500000534 03.10.2007',
        nameOfWork: 'Rate Contract For Providing new PNG Connections In NCT Of Delhi',
        clientAddr: 'Indraprastha Gas Limited, Plot No. 4, IGL Bhawan, Sector- 9, R.K. Puram, New Delhi - 110 022',
        woValue: '50,00,000',
        exValue: '50,00,000',
        startDate: '03.10.2007',
        endDate: '01-08-2008',
        duration: '12 Month',
        remarks: 'IGL/ND/C & P/P10162 Dtd. 28.02.2008',
      },
    ],
  },
  {
    heading: 'ARC FOR MECHANICAL MAINTENANCE OF U.P. PETROCHEMICAL COMPLEX, GAIL INDIA LTD. PATA.',
    projects: [
      {
        id: 1,
        sr: 1,
        loa: 'GAIL/PA07/11438/5300007835/RK Dtd. 28.06.2007',
        nameOfWork: 'Rate Contract for Electro Mechanical Maint. In IOP&S, Power Plant Units at GAIL, Pata.',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '79,03,725',
        exValue: '----',
        startDate: '26.06.2007',
        endDate: 'Completed',
        duration: '24 Month',
        remarks: '----',
      },
      {
        id: 2,
        sr: 2,
        loa: 'GAIL/PA07/12618/5300008635/LK/07 Dtd. 08.11.2007',
        nameOfWork: 'Rate Contract for Electrical Maint. In GCU Units at GAIL, Pata.',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '61,23,600',
        exValue: '----',
        startDate: '08.11.2007',
        endDate: 'Completed',
        duration: '24 Month',
        remarks: '----',
      },
      {
        id: 3,
        sr: 3,
        loa: 'GAIL/PA07/10173/5300007674/RK Dtd. 29.05.2007',
        nameOfWork: 'Rate Contract for Mech. Maint. In Downstream Units at GAIL, Pata.',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '1,54,93,767',
        exValue: '----',
        startDate: '21.05.2007',
        endDate: 'Completed',
        duration: '24 Month',
        remarks: 'Completed',
      },
      {
        id: 4,
        sr: 4,
        loa: 'GAIL/PATA/C & P/R04074/SK/WK-098/2004 Dtd. 02.12.2004',
        nameOfWork: 'Rate Contract for Mech. Maint. In Downstream Units at GAIL, Pata.',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '1,67,00,846',
        exValue: '1,12,00,000',
        startDate: '02.12.2004',
        endDate: '20.05.2007',
        duration: '18 Month',
        remarks: 'Refer Amendment-3 Dtd. 17.11.2006',
      },
      {
        id: 5,
        sr: 5,
        loa: 'GAIL/PATA/C & P/R04074/SK/WK-098/2004 Dtd. 02.12.2004',
        nameOfWork: 'Rate Contract for Mech. Maint. In Downstream Units at GAIL, Pata.',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '1,51,80,846',
        exValue: '1,67,00,846',
        startDate: '20.12.2004',
        endDate: '20.05.2007',
        duration: '24 Month',
        remarks: 'Refer Amendment NO. 1, 2 & 3',
      },
      {
        id: 6,
        sr: 6,
        loa: 'GAIL/UPPC/C & P/R02005/AS/WK-094/2002 Dtd. 29.05.2007',
        nameOfWork: 'Rate Contract for Mech. Maint. In Downstream Units at GAIL, Pata.',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '97,25,968',
        exValue: '1,16,71,161',
        startDate: '17.02.2003',
        endDate: '26.02.2005',
        duration: '24 Month',
        remarks: 'Refer Amendment No. 1 & 2',
      },
      {
        id: 7,
        sr: 7,
        loa: 'GAIL/UPPC/C & P/R02005/AS/WK-094/2002 Dtd. 29.05.2007',
        nameOfWork: 'Rate Contract for Mech. Maint. In Downstream Units at GAIL, Pata.',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '46,56,661',
        exValue: '90,94,843',
        startDate: '06.08.2002',
        endDate: '20.11.2004',
        duration: '24 Month',
        remarks: 'Refer Amendment No. 1, 2, 3, 4 & 5',
      },
      {
        id: 8,
        sr: 8,
        loa: 'GAIL/PA11/33019/5300016447/VA/',
        nameOfWork:
          'ARC FOR O & M OF CONSTRUCTION EQUIPMENTS, EOT/HOT CRANES, MONORAILS, FORKLIFTERS, AND BATTERY OPERATED TRUCK AT GAIL PATA',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '6,466,558.1',
        exValue: '----',
        startDate: '----',
        endDate: '----',
        duration: '----',
        remarks: 'COMPLETED',
      },
      {
        id: 9,
        sr: 9,
        loa: 'GAIL /PA11/32967/5300017330/RK',
        nameOfWork: 'ARC OF GAS CRACKER UNIT',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '12,348,542.75',
        exValue: '----',
        startDate: '----',
        endDate: '----',
        duration: '----',
        remarks: 'COMPLETED',
      },
      {
        id: 10,
        sr: 10,
        loa: 'GAIL/PA12/35582/5300018127/VA',
        nameOfWork: 'REPLACEMENT OF RADIANT COIL IN FURNACE AT GCU UNIT',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '4,649,681.52',
        exValue: '----',
        startDate: '----',
        endDate: '----',
        duration: '----',
        remarks: 'COMPLETED',
      },
      {
        id: 11,
        sr: 11,
        loa: 'GAIL/PA11/34051/5300017759/RK',
        nameOfWork: 'ARC OF LLDPE & B-1 PLANT',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '18,271,517.63',
        exValue: '----',
        startDate: '----',
        endDate: '----',
        duration: '----',
        remarks: 'COMPLETED',
      },
      {
        id: 12,
        sr: 12,
        loa: 'GAIL/PA11/35562/5600001448/VA',
        nameOfWork:
          'SERVICE CONTRACT FOR PIPING FABRICATION. ERECTION WORK FOR EJECTOR BASED VAPOUR RECOVERY UNIT AT GAIL PATA',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '4,182,024.5',
        exValue: '3,007,653.23',
        startDate: '----',
        endDate: '----',
        duration: '----',
        remarks: '----',
      },
      {
        id: 13,
        sr: 13,
        loa: 'GAIL/PA14/45114/56000021925/KN 05/03/2014',
        nameOfWork: 'ARC FOR ELECTRICAL & MECHANICAL MAINT. IN GCU',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '17,932,981',
        exValue: '----',
        startDate: '----',
        endDate: '----',
        duration: '24 MONTH',
        remarks: 'COMPLETED',
      },
      {
        id: 14,
        sr: 14,
        loa: 'GAIL/PA16/60592/56000025251/SKS 12/04/2016',
        nameOfWork: 'ARC FOR ELECTRICAL & MECHANICAL MAINT. IN GCU',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '24,215,148',
        exValue: '----',
        startDate: '----',
        endDate: '----',
        duration: '24 MONTH',
        remarks: 'RUNNING',
      },
      {
        id: 15,
        sr: 15,
        loa: 'GAIL/PA14/47546/56000022114/KN 28/04/2014',
        nameOfWork: 'ARC FOR ELECTRICAL & MECHANICAL MAINT. IN IOP &S',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '16,568,917',
        exValue: '---',
        startDate: '---',
        endDate: '---',
        duration: '24 MONTH',
        remarks: 'COMPLETED',
      },
      {
        id: 16,
        sr: 16,
        loa: 'GAIL/PA15/53658/5300024247/VS 17/08/2015',
        nameOfWork: 'ARC FOR MECH. MAINT. IN GPU',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '9,559,384',
        exValue: '---',
        startDate: '---',
        endDate: '---',
        duration: '24 MONTH',
        remarks: 'RUNNING',
      },
      {
        id: 17,
        sr: 17,
        loa: 'GAIL/PA14/50429/5300022755/SS 29 /09/2014',
        nameOfWork:
          'Replacement of complete set of Radiant Coils in 4 nos of Gas Cracking Furnaces in GCU at GAIL, UPPC, Pata.',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '3,821,200',
        exValue: '---',
        startDate: '---',
        endDate: '---',
        duration: '24 MONTH',
        remarks: 'COMPLETED',
      },
      {
        id: 18,
        sr: 18,
        loa: 'GAIL/PA15/54738/5300023703/DK 18/04/2015',
        nameOfWork: 'SERVICE CONTRACT FOR MECH. ASSIST. COLUMN & VESSELS',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '4,492,149',
        exValue: '---',
        startDate: '---',
        endDate: '---',
        duration: '24 MONTH',
        remarks: 'COMPLETED',
      },
      {
        id: 19,
        sr: 19,
        loa: 'GAIL/PA13/44138/5300021100/MS',
        nameOfWork:
          'SERVICE CONTRACT FOR MECHANICAL ASSISTANCE DURING NDT INSPECTION OF STATIC EQUIPMENT FOR ASSESSING HEALTH OF',
        clientAddr: 'GAIL (India) Ltd. Pata, Dist. Auraiya, U.P.',
        woValue: '7,677,053.18',
        exValue: '---',
        startDate: '---',
        endDate: '---',
        duration: '24 MONTH',
        remarks: '---',
      },
    ],
  },
  {
    heading: 'ARC FOR REPAIR & MAINTENANCE OF FIRE WATER NETWORK',
    projects: [
      {
        id: 1,
        sr: 1,
        loa: 'P.O. No. 963230',
        nameOfWork: 'Reinstallation of 144 Nos Burners of Furnace ( Welding of Venture to intermediate plates )',
        clientAddr: 'John Zinc International Luxembourg SARL',
        woValue: '6676 Euros + 10.2 % Tax',
        exValue: '6676 Euors + 10.2 % Tax',
        startDate: '15.07.2005',
        endDate: '11.08.2005',
        duration: '1 Month',
        remarks: '--',
      },
    ],
  },
];

export const METHODLOGY_DATA = [
  {
    heading: 'Meet Customer',
    content: 'Our engineers will meet the customer to gather information.',
  },
  {
    heading: 'Requirement Analysis',
    content: 'Our engineers will meet the customer to gather information.',
  },
  {
    heading: 'Feasibility Study',
    content: 'Our engineers will meet the customer to gather information.',
  },
  {
    heading: 'Design & Implementation',
    content: 'Our engineers will meet the customer to gather information.',
  },
];

export const INDUSTRY_LINKS = [
  { src: '/footer-img.jpg', alt: 'industry', text: 'Petrochemical' },
  { src: '/gas.jpg', alt: 'industry', text: 'Gas Utility Line works' },
  { src: '/powerplant.jpg', alt: 'industry', text: 'Power Plants' },
  { src: '/electrical.jpg', alt: 'industry', text: 'Electrical Utility Works' },
  { src: '/station.jpg', alt: 'industry', text: '33/11 Sub station works' },
  { src: '/refine.jpg', alt: 'industry', text: 'Refineries' },
  { src: '/restore.jpg', alt: 'industry', text: 'Restoration' },
  { src: '/water.jpg', alt: 'industry', text: 'Water/Waste water' },
  { src: '/advertisement.jpg', alt: 'industry', text: 'Advertisement' },
  { src: '/Mining.jpg', alt: 'industry', text: 'Mining (Sand/Morrum)' },
  { src: '/ev-charging-station.jpg', alt: 'industry', text: 'EV Charging Station' },
  { src: '/bino-vision.jpg', alt: 'industry', text: 'Comprehensive Solutions for Indian Army' },
];

export const ARMY_PRODUCTS = [
  { src: './NM-3000.jpg', alt: 'Indian Army', link: 'https://www.mku.com/en-gb/' },
  { src: './NM-3001.jpg', alt: 'Indian Army', link: 'https://www.mku.com/en-gb/' },
  { src: './NM-3300.jpg', alt: 'Indian Army', link: 'https://www.mku.com/en-gb/' },
  { src: './TW-4100.jpg', alt: 'Indian Army', link: 'https://www.mku.com/en-gb/' },
  { src: './TD-5100.jpg', alt: 'Indian Army', link: 'https://www.mku.com/en-gb/' },
];
